import { useEffect, useState } from "react";
import { Accessibility, X } from "lucide-react";

const OPTIONS = [
  { key: "a11y-large-text", label: "Larger text" },
  { key: "a11y-high-contrast", label: "High contrast" },
  { key: "a11y-reduce-motion", label: "Reduce motion" },
  { key: "a11y-underline-links", label: "Underline links" },
  { key: "a11y-focus-visible", label: "Enhanced focus outlines" },
];

export function AccessibilityWidget() {
  const [open, setOpen] = useState(false);
  const [prefs, setPrefs] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cocoa_a11y") || "{}"); } catch { return {}; }
  });

  useEffect(() => {
    OPTIONS.forEach(({ key }) => document.documentElement.classList.toggle(key, !!prefs[key]));
    localStorage.setItem("cocoa_a11y", JSON.stringify(prefs));
  }, [prefs]);

  const toggle = (key) => setPrefs((p) => ({ ...p, [key]: !p[key] }));

  return (
    <>
      <button data-testid="a11y-toggle-btn" aria-label="Accessibility options" title="Accessibility options"
        onClick={() => setOpen(!open)}
        className="fixed bottom-5 right-5 z-[90] flex h-12 w-12 items-center justify-center rounded-full bg-[#1565C0] text-white shadow-lg hover:bg-[#0D47A1] focus:outline-none focus:ring-4 focus:ring-[#1565C0]/40 transition-colors">
        <Accessibility size={22} />
      </button>
      {open && (
        <div role="dialog" aria-label="Accessibility settings" data-testid="a11y-panel"
          className="fixed bottom-20 right-5 z-[90] w-72 rounded-2xl border border-[#EFEBE0] bg-white p-4 shadow-2xl">
          <div className="mb-3 flex items-center justify-between">
            <h3 className="font-heading text-sm font-bold text-[#3E2723]">Accessibility</h3>
            <button data-testid="a11y-close-btn" aria-label="Close accessibility panel" onClick={() => setOpen(false)}
              className="rounded-full p-1 text-[#7B6157] hover:bg-[#F5F2EB]"><X size={16} /></button>
          </div>
          <div className="space-y-1.5">
            {OPTIONS.map(({ key, label }) => (
              <button key={key} data-testid={`${key}-toggle`} role="switch" aria-checked={!!prefs[key]} onClick={() => toggle(key)}
                className="flex w-full items-center justify-between rounded-xl px-3 py-2.5 text-sm text-[#3E2723] hover:bg-[#F5F2EB] focus:outline-none focus:ring-2 focus:ring-[#1565C0]">
                {label}
                <span className={`relative h-5 w-9 rounded-full transition-colors ${prefs[key] ? "bg-[#1565C0]" : "bg-[#D7CCC8]"}`}>
                  <span className={`absolute top-0.5 h-4 w-4 rounded-full bg-white shadow transition-transform ${prefs[key] ? "translate-x-4.5 left-0.5 translate-x-[18px]" : "left-0.5"}`} />
                </span>
              </button>
            ))}
          </div>
          <p className="mt-3 text-[11px] text-[#84675B]">Preferences are saved on this device. Cocoa EHR aims for WCAG 2.1 AA conformance.</p>
        </div>
      )}
    </>
  );
}
